import { useZero } from "@rocicorp/zero/react";
import { useRef } from "react";
import { sharedMutators } from "../../../shared/mutators";
import { NoteInput } from "../NoteInput";
import type { App } from "./Form";

const MAX_LENGTH = 280;

type Props = {
  app: App;
  disabled?: boolean;
};

export function NoteField({ app, disabled }: Props) {
  const z = useZero();
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

  const save = (value: string) => {
    z.mutate(
      sharedMutators.updateConnectedApp({
        connectedAppId: app.id,
        name: app.name,
        identifier: app.identifier,
        urlPattern: app.urlPattern,
        configuration: app.configuration,
        note: value.slice(0, MAX_LENGTH),
      })
    );
  };

  return (
    <NoteInput
      label="Note"
      helperText="Helps your team and 3B know when and how to use this connector."
      readOnly={disabled}
      defaultValue={app.note ?? ""}
      placeholder="e.g. Production account, only use for live deploys"
      maxLength={MAX_LENGTH}
      onChange={(value) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => save(value), 2000);
      }}
      onBlur={(value) => {
        clearTimeout(timeoutRef.current);
        if (!disabled) save(value);
      }}
    />
  );
}
